<template>
  <div>
    <div class="successhtml">
      <div class="successbody">
        <div class="successbodytext">
          <div class="successleft">
            <div class="martop">成功案例</div>
            <div
              v-for="(item, index) in form"
              :key="index"
              @click="choosearea(index)"
              v-bind:class="[item ? class1 : class2]"
            >
              <div>
                {{ formn[index] }}
              </div>
              <!-- <div v-bind:class="[item ? class3 : class4]"></div> -->
            </div>
          </div>
          <div class="successright">
            <div class="righttext">
              <!-- <div v-for="(item,index) in form" :key="index"  :class="{disp:item==false}"> -->
              <div>
                <table style="margin: 0 auto; border: 1px solid #c9d8f7">
                  <tr>
                    <td
                      style="
                        width: 620px;
                        background: #e2e8f4;
                        text-align: center;

                        padding-left: 0px;
                      "
                    >
                      公司名称
                    </td>
                  </tr>
                  <tbody>
                    <tr
                      v-for="(item1, index1) in formpage"
                      :key="index1"
                      @click="goto(item1.website)"
                    >
                      <td :class="{ active: item1.website != '' }">
                        {{ item1.companyname }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="successcomfoot">
                <div
                  v-for="(it, id) in yeshu"
                  v-bind:key="id"
                  @click="choosepage(id + 1, area)"
                  class="pagebutton"
                  :class="{ pageclickbutton: yeshu[id] == true }"
                >
                  {{ id + 1 }}
                </div>
                共{{ page }}页，{{ tiao }}条
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <wh8footer></wh8footer>
  </div>
</template>

<script>
import wh8footer from "./components/wh8/wh8footer.vue";
import axios from "axios";
export default {
  data() {
    return {
      class1: "clicktext",
      class2: "lefttext",
      form: {
        bj: true,
        sh: false,
        gd: false,
        zj: false,
        others: false,
      },
      formn: {
        bj: "北京",
        sh: "上海",
        gd: "广东",
        zj: "浙江",
        others: "其他地区",
      },
      class3: "showsanjiao",
      class4: "nosanjiao",
      tiao: "",
      page: "",
      yeshu: "",
      formtextall: {
        bj: [
          
        ],
        sh: [],
        gd: [],
        zj: [],
        others: [],
      },
      formtext: {
        bj: [],
        sh: [],
        gd: [],
        zj: [],
        others: [],
      },
      formpage: "",
      youxi: "",
      area: "bj",
    };
  },
  components: { wh8footer },

  methods: {
    choosearea(idx) {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });

      this.yeshu = [];
      this.area = idx;

      this.form[idx] = true;

      this.tiao = this.formtextall[idx].length;
      this.page = Math.ceil(this.formtextall[idx].length / 11);

      for (var it = 0; it < this.page; it++) {
        this.$set(this.yeshu, it, false);
      }

      this.choosepage(1, idx);
    },
    choosepage(p, idx) {
      this.formtext = {
        bj: [],
        sh: [],
        gd: [],
        zj: [],
        others: [],
      };
      for (var it = 0; it < this.page; it++) {
        this.$set(this.yeshu, it, false);
      }
      this.yeshu[p - 1] = true;

      if (this.formtextall[idx].length < p * 11) {
        for (var x = (p - 1) * 11; x < this.formtextall[idx].length; x++) {
          this.$set(
            this.formtext[idx],
            x - (p - 1) * 11,
            this.formtextall[idx][x]
          );
        }
      } else {
        for (var y = (p - 1) * 11; y < p * 11; y++) {
          this.$set(
            this.formtext[idx],
            y - (p - 1) * 11,
            this.formtextall[idx][y]
          );
        }
      }

      this.formpage = this.formtext[idx];
    },
    goto(newpage) {
      if (newpage != "") {
        window.open(newpage, "_blank");
      }
    },
  },
  mounted() {
    axios
      .get("/api/case.asp")
      .then((res) => {
        // console.log(res);
        res.data.forEach((item)=>{
          if(item.psort == 1){
              this.formtextall.bj.push(item)
          }else if(item.psort == 2){
              this.formtextall.sh.push(item)
          }else if(item.psort == 3){
              this.formtextall.gd.push(item)
          }else if(item.psort == 4){
              this.formtextall.zj.push(item)
          }else if(item.psort == 5){
              this.formtextall.others.push(item)
          }
        })
        // this.formtextall = res.data;
        this.choosearea("bj");

      })
      .catch((err) => {
        console.log(err);
      });


  },
};
</script>

<style scoped>
.success{
  position: absolute;
    top: 73px;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
}
td.active {
  cursor: pointer;
}
td.active:hover {
  color: blue;
}
.successcomfoot {
  width: 620px;
  margin-left: 74px;
  height: 40px;
  margin-top: 20px;
  text-align: right;
}
.pagebutton {
  display: inline-block;
  height: 25px;
  width: 25px;
  margin-right: 15px;
  border: 1px solid #dfdfdf;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  color: #adadad;
  user-select: none;
}
.pageclickbutton {
  display: inline-block;
  height: 25px;
  width: 25px;
  margin-right: 15px;
  border: 1px solid #dfdfdf;
  color: white;
  text-align: center;
  line-height: 25px;
  background: #22427d;
  cursor: pointer;
  user-select: none;
}
.martop {
  /* margin-top: 60px; */
  color: #fff;
  font-weight: 700;
  padding-left: 30px;
  height: 60px;
}
.disp {
  display: none;
}
.successhtml {
  /* margin-top: 20px; */
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=41) no-repeat top;
  background-size: 100% auto;
  /* height: 660px; */
  min-width: 1400px;
  width: 100%;
  padding-top: 110px;
  flex-grow:1;

}
.successhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.successheadtext {
  position: absolute;
  top: 100px;
}
.successbody {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  /* height: 635px; */
}
.successbodytext {
  width: 1010px;
  margin: 0 auto;
  height: 100%;
  /* height: 635px; */
  position: relative;
  min-height: 650px;
}
.successleft {
  /* float: left; */
  padding-top: 60px;
  width: 250px;
  background: url("../../assets/images/cgal.png") no-repeat top;
  background-size: 100% auto;
  /* height: 635px; */
  height: 345px;
}
.successright {
  /* float: left; */
  position: absolute;
  width: 760px;
  background: #ebf2fc;
  /* background-size: 100% 100%; */
  /* min-height: 5px; */
  margin-left: -45px;
  margin-top: 30px;
  border-radius: 10px 0 0 0;
  box-shadow: -2px 0px rgb(65 97 153 / 10%);
  top: 5px;
  left: 250px;
  bottom: 0;
}
.lefttext {
  font-size: 14px;
  line-height: 40px;
  position: relative;
  z-index: 99;
  /* margin-top: 15px; */
  letter-spacing: 1px;
  color: #1a2747;
  /* text-align: center; */
  text-indent: 2em;
  /* border-bottom: 1px dashed #a4acbf; */
  cursor: pointer;
  font-weight: bold;
  padding-left: 20px;
}
.clicktext {
  position: relative;
  z-index: 99;
  font-size: 14px;
  line-height: 40px;
  background: #ebf2fc;
  letter-spacing: 1px;
  color: #1a2747;
  border-left: 5px solid #d6b65b;
  /* margin-left: -3px; */
  text-indent: 2em;
  /* border-bottom: 1px dashed #a4acbf; */
  cursor: pointer;
  font-weight: bold;
  padding-left: 15px;
}
.clicktext div,
.lefttext div {
  width: 160px;
  border-bottom: 1px dashed #a4acbf;
}
.lefttext:hover {
  color: #e3a200;
}
.showsanjiao {
  width: 250px;
  height: 10px;
  background: url("../../assets/images/cgal.png") no-repeat left;
}
.nosanjiao {
  width: 250px;
  height: 10px;
}
.righttext {
  margin-top: 60px;
}
td {
  height: 35px;
  border-bottom: 1px solid #eeeeee;
  line-height: 35px;
  vertical-align: middle;
  font-size: 14px;
  padding-left: 40px;
  letter-spacing: 1px;
  color: #323232;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
tbody tr:nth-child(even) {
  background: #f5f8ff;
}
tr:last-child td {
  border: none;
}
</style>